import React from 'react';
import { createPortal } from 'react-dom';
import logo from '../assets/image/logo_web.png';

export default function ServerStatusModal({ open, onClose, status }) {
  if (!open) return null;

  const checks = status?.checks || {};

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/60 p-4 overflow-y-auto">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-xl w-full p-6 mt-8 mb-8 relative z-[10000]">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Logo" className="h-10 w-auto" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Server status details</h3>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">✕</button>
        </div>

        <div className="mt-4 space-y-3">
          <div className="flex items-center justify-between p-3 border rounded bg-gray-50 dark:bg-gray-900">
            <div>
              <div className="font-medium">Auth</div>
              <div className="text-xs text-gray-500">Authentication availability</div>
            </div>
            <div className={checks.auth?.ok ? 'text-green-700 font-medium' : 'text-rose-700 font-medium'}>
              {checks.auth?.ok ? 'OK' : (checks.auth?.error || 'Unavailable')}
            </div>
          </div>

          <div className="flex items-center justify-between p-3 border rounded bg-gray-50 dark:bg-gray-900">
            <div>
              <div className="font-medium">Firestore</div>
              <div className="text-xs text-gray-500">Read test against users/profile</div>
            </div>
            <div className={checks.firestore?.ok ? 'text-green-700 font-medium' : 'text-rose-700 font-medium'}>
              {checks.firestore?.ok ? 'OK' : (checks.firestore?.error || 'Unavailable')}
            </div>
          </div>

          <div className="flex items-center justify-between p-3 border rounded bg-gray-50 dark:bg-gray-900">
            <div>
              <div className="font-medium">Storage</div>
              <div className="text-xs text-gray-500">List test on user/company path</div>
            </div>
            <div className={checks.storage?.ok ? 'text-green-700 font-medium' : 'text-rose-700 font-medium'}>
              {checks.storage?.ok ? 'OK' : (checks.storage?.error || 'Unavailable')}
            </div>
          </div>

          {/* Functions check removed: callable 'ping' hidden by request */}

          {status?.durationMs != null && (
            <div className="text-xs text-gray-500">Probe time: {status.durationMs}ms</div>
          )}
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-100 dark:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
